export const APP_HEADER = {
  APPLICATION: 'Application',
  NOMINATION: 'Nomination',
  ASSESSMENT: 'Assessment',
  SWITCH_ROLE: 'Switch Your Role',
  LOG_OUT: 'Log Out',
  EXIT_DELEGATION: 'Exit Delegation',
  DELEGATION: 'Delegation',
  MOCK_USER: 'Mock User',
  SUPER_ADMIN: 'Super Admin',
};

export const PROFILE = {
  EMAIL_ACCOUNT: 'Email Account',
  NAME: 'Name',
  CURRENT_ROLE: 'Current Role',
  DELEGATING: 'Delegating',
  ROLE: 'Role',
  SUPERVISOR: 'Supervisor',
};

export const DIALOG_TEXT = {
  LOGOUT: {
    KEY: 'LOGOUT',
    TITLE: `Log Out`,
    CONTENT: `Are you sure you want to log out?`,
  },
  EXIT_DELEGATION: {
    KEY: 'EXIT_DELEGATION',
    TITLE: `Exit Delegation`,
    CONTENT: `Are you sure you want to exit the delegation?`,
  },
  IDLE_SHORT: {
    KEY: 'IDLE_SHORT',
    TITLE: `You've been inactive for 15 minutes.`,
    CONTENT: `If you're done, consider logging out for security.`,
  },
  IDLE_LONG: {
    KEY: 'IDLE_LONG',
    TITLE: `You've been inactive for 15 minutes`,
    CONTENT: `For privacy and security reasons, you've been automatically logged out. Please log in again.`,
  },
};
